import React, { PropsWithChildren } from 'react'
import { Center } from '../../parts/bases/Center'
import { HStack } from '../../parts/bases/HStack'
import { Text } from '../../parts/bases/Text'
import { VStack } from '../../parts/bases/VStack'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import {
  Layout as GlobalNavigationHeader,
  Props as GlobalNavigationHeaderProps,
} from '../../parts/commons/GlobalNavigationHeader/Layout'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'
import LoginFrame from '@/public/images/loginFrame.png'
import MetamaskLogo from '@/public/images/metamaskLogo.png'
import Link from 'next/link'
import { PagePathService } from '@/src/services/PagePathService'

export type Props = {
  onUpdateEmail: (email: string) => void
  onClickEmailLogin: () => void
  onClickMetamaskLogin: () => void
  disabledSubmit: boolean
  visibleMetamaskLoginIndicator: boolean
  visibleEmailLoginIndicator: boolean
  GlobalNavigationHeaderProps: GlobalNavigationHeaderProps
}

export const Layout: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <VStack className="h-screen w-full">
      <GlobalNavigationHeader {...props.GlobalNavigationHeaderProps} />
      <Center className="w-full flex-1 items-center pb-20">
        <VStack className="w-[700px] items-center p-[18px]">
          <Frame>
            <VStack className="mt-10 w-full max-w-[700px] flex-1 items-center justify-center">
              <form className="flex w-full">
                <VStack className="w-full items-center">
                  <HStack className="mt-4 w-full items-center">
                    <Text className="text-sm font-bold text-neon-blue">{t('LoginPage.EmailLabel')}</Text>
                    <input
                      className="ml-20 flex-1 rounded-lg border-2 border-neutral-800 bg-black p-2 font-bold text-white caret-neon-blue outline-0 focus:border-neon-blue"
                      onChange={(e) => props.onUpdateEmail(e.target.value)}
                    />
                  </HStack>
                  <Center className="my-9">
                    <PinkNeonButton onClick={props.onClickEmailLogin} disabled={props.disabledSubmit}>
                      {t(
                        props.visibleEmailLoginIndicator
                          ? 'LoginPage.SubmitProcessing'
                          : 'LoginPage.EmailLoginButton',
                      )}
                    </PinkNeonButton>
                  </Center>
                </VStack>
              </form>
            </VStack>
            <HStack className="relative items-center justify-center">
              <VStack className="h-px flex-1 bg-neon-blue bg-opacity-30" />
              <Text className="mx-4 text-neon-blue">or</Text>
              <VStack className="h-px flex-1 bg-neon-blue bg-opacity-30" />
            </HStack>
            <VStack className="my-4 flex-1 items-center">
              <Center className="relative mb-8 mt-4 aspect-[99/90] w-24">
                <Image src={MetamaskLogo} layout="fill" alt="" />
              </Center>
              <PinkNeonButton
                onClick={props.onClickMetamaskLogin}
                disabled={props.visibleMetamaskLoginIndicator}
              >
                {t(
                  props.visibleMetamaskLoginIndicator
                    ? 'LoginPage.SubmitProcessing'
                    : 'LoginPage.MetamaskLoginButton',
                )}
              </PinkNeonButton>
              <HStack className="mt-8">
                <Text className="text-white">{t('LoginPage.SignUpLinkText')}</Text>
                <Link href={PagePathService.signup()} passHref legacyBehavior>
                  <a className="ml-2 text-akiverse-pink">{t('LoginPage.SignUpLinkLinkText')}</a>
                </Link>
              </HStack>
            </VStack>
          </Frame>
        </VStack>
      </Center>
    </VStack>
  )
}

const Frame = ({ children }: PropsWithChildren) => (
  <VStack className="h-full w-full">
    <VStack className={`top-0 left-0 bottom-0 aspect-[2265/2019] w-full px-12 pt-14 pb-3`}>
      <Image src={LoginFrame} layout="fill" alt="" />
      {children}
    </VStack>
  </VStack>
)
